import { render, staticRenderFns } from "./TriageCalculationAdditionalCriteria.vue?vue&type=template&id=f904cb22"
import script from "./TriageCalculationAdditionalCriteria.vue?vue&type=script&lang=ts"
export * from "./TriageCalculationAdditionalCriteria.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports